import * as THREE from 'three';

export class ActivityRing {
  public mesh: THREE.Mesh;
  private radius: number;
  private expansion: number;
  private opacity: number;
  private lifespan: number;
  private age: number;

  constructor(planetRadius: number) {
    this.radius = planetRadius;
    this.expansion = 0;
    this.opacity = 1.0;
    this.lifespan = 2.0; // 2 seconds
    this.age = 0;
    
    // Create ring geometry
    const geometry = new THREE.RingGeometry(
      this.radius * 1.1,
      this.radius * 1.2,
      32
    );
    
    // Create ring material
    const material = new THREE.MeshBasicMaterial({
      color: 0x44ff88,
      transparent: true,
      opacity: this.opacity,
      side: THREE.DoubleSide,
      blending: THREE.AdditiveBlending
    });
    
    this.mesh = new THREE.Mesh(geometry, material);
    this.mesh.rotation.x = Math.PI / 2; // Face camera
  }

  public update(deltaTime: number): void {
    this.age += deltaTime;
    
    // Calculate progress (0 to 1)
    const progress = this.age / this.lifespan;
    
    // Expand ring
    this.expansion = progress * this.radius;
    const scale = 1 + this.expansion / this.radius;
    this.mesh.scale.set(scale, scale, 1);
    
    // Fade out
    this.opacity = Math.pow(1 - progress, 2);
    if (this.mesh.material instanceof THREE.MeshBasicMaterial) {
      this.mesh.material.opacity = this.opacity;
    }
  }

  public isDead(): boolean {
    return this.age >= this.lifespan;
  }

  public dispose(): void {
    if (this.mesh.parent) {
      this.mesh.parent.remove(this.mesh);
    }
    
    if (this.mesh.geometry) {
      this.mesh.geometry.dispose();
    }
    
    if (this.mesh.material) {
      if (Array.isArray(this.mesh.material)) {
        this.mesh.material.forEach(mat => mat.dispose());
      } else {
        this.mesh.material.dispose();
      }
    }
  }
}